// extracted by mini-css-extract-plugin
export default {"tag":"tag_tag__FqBuB","selected":"tag_selected__+32BX","name":"tag_name__T1ygR","expand":"tag_expand__3qhA0"};